import React from "react";
import { PaperProps } from "../../interfaces/components/paper";

const Paper: React.FC<PaperProps> = ({
  children,
  className = "",
  elevation = 1,
  ...props
}) => {
  const elevationClass = {
    0: "",
    1: "shadow-sm",
    2: "shadow-md",
    3: "shadow-lg",
  }[elevation];

  return (
    <div
      className={`bg-white dark:bg-darkCardBackground rounded-lg ${elevationClass} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default Paper;
